import React from 'react';
import T from 'prop-types';
import { MenuOutlined } from '@ant-design/icons';

import { Container, NavButton, StyledDrawer } from './style';

import { MOBILE_NAV_WIDTH } from '../../constants/ui';

import SignupButton from '../signupButton';
import AuthenticationGate from '../authenticationGate';
import UserMenu from '../userMenu';

import NavigationDrawer from './subcomponents/navigationDrawer';

const NavigationMobile = ({ showMobileNav, hideMobileNav, isVisible }) => (
  <Container>
    <AuthenticationGate fallbackComponent={<SignupButton />}>
      <UserMenu />
    </AuthenticationGate>

    <NavButton
      data-cy="nav-menu-btn-mobile"
      icon={<MenuOutlined />}
      onClick={showMobileNav}
      shape="circle"
      size="large"
    />
    <StyledDrawer onClose={hideMobileNav} placement="right" visible={isVisible} width={MOBILE_NAV_WIDTH}>
      <NavigationDrawer onNavLinkClick={hideMobileNav} />
    </StyledDrawer>
  </Container>
);

NavigationMobile.propTypes = {
  isVisible: T.bool.isRequired,
  hideMobileNav: T.func.isRequired,
  showMobileNav: T.func.isRequired,
};

export default NavigationMobile;
